<!-- comments -->
<div class="sticky">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</div>

<ion-content>


  <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <ion-list>
    <ion-item lines="none" *ngFor="let comment of comments">
      <div slot="start" class="avatar-letters-2 absolute-center">
        <ion-label>
          {{comment?.user.first_name[0]}}{{comment?.user.last_name[0]}}
        </ion-label>
      </div>
      <ion-label>
        <h3>{{comment?.user.first_name}} {{comment?.user.last_name}}</h3>
        <p class="comment"> {{comment?.text}}</p>
      </ion-label>
      <button *ngIf="comment.user.id == authService.player_initial_data.user.id;" mat-icon-button
        [matMenuTriggerFor]="editDeleteMenu" class="three-dots" aria-label="Edit-Delete menu">
        <ion-icon name="ellipsis-vertical-outline"></ion-icon>
      </button>
      <mat-menu [style.visibility]="(comment.user.id == authService.player_initial_data.user.id) ? 'visible':'hidden'"
        #editDeleteMenu="matMenu">
        <button mat-menu-item (click)="editComment(comment)">
          <ion-icon class="edit-delete-icon" name="create-outline"></ion-icon>
          <span>Editar</span>
        </button>
        <button mat-menu-item (click)="removeComment(comment)">
          <ion-icon class="edit-delete-icon" name="trash-outline"></ion-icon>
          <span>Borrar</span>
        </button>
      </mat-menu>
    </ion-item>

    <ion-item *ngIf="comments.length == 0 && !loading">
      <ion-label>Se el primero en comentar</ion-label>
    </ion-item>

  </ion-list>


  <!--INFINITE SCROLL-->
  <ion-infinite-scroll threshold="100px" (ionInfinite)="getComments()">
    <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Cargando más comentarios...">
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>



<!-- new comment -->
<ion-item lines="none" class="new-comment">
  <ion-textarea placeholder="Escribe un comentario" [formControl]="formControl"></ion-textarea>
  <img style="width: 20px; height: 20px; margin: auto;" class="clickable" slot="end" src="../../../assets/icon/send.png"
    (click)="createComment()">
</ion-item>